import React from 'react';
import { BRANDING } from '../config';

function InsightsScheduleCard() {
  const schedules = [
    {
      label: 'Daily Report',
      schedule: 'Every morning at 9:00 AM ET',
      description: 'Analyzes the last 24 hours of narcotic inventory logs across all units.',
    },
    {
      label: 'Weekly Report',
      schedule: 'Every Monday at 9:00 AM ET',
      description: 'Strategic intelligence report covering 7-day trends, patterns, and recommendations.',
    },
  ];

  return (
    <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }}>
      <div style={{ background: BRANDING.primaryColor, color: '#fff', padding: '16px 20px' }}>
        <h3 style={{ margin: 0, fontSize: '16px' }}>AI Insights Schedule</h3>
      </div>
      <div style={{ padding: '20px' }}>
        {schedules.map((item, i) => (
          <div key={i} style={{ marginBottom: i < schedules.length - 1 ? '16px' : 0, padding: '12px', background: '#f8f9fa', borderRadius: '6px', borderLeft: `4px solid ${BRANDING.primaryColor}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
              <strong style={{ fontSize: '14px', color: '#333' }}>{item.label}</strong>
              <span style={{ background: BRANDING.primaryColor, color: '#fff', padding: '3px 10px', borderRadius: '12px', fontSize: '11px' }}>{item.schedule}</span>
            </div>
            <p style={{ margin: 0, fontSize: '12px', color: '#666', lineHeight: '1.4' }}>{item.description}</p>
          </div>
        ))}
        <p style={{ margin: '16px 0 0', fontSize: '11px', color: '#94a3b8', textAlign: 'center' }}>
          Scheduled via pg_cron. Reports are emailed to all admin users and stored in the insights dashboard.
        </p>
      </div>
    </div>
  );
}

export default InsightsScheduleCard;
